import PetFeeder from "../assets/images/portfolio/pet-feeder2.jpg";
import PlantDisease from "../assets/images/portfolio/plant-disease.jpg";
import ParkingSystem from "../assets/images/portfolio/parking-system.jpg";
import UWC from "../assets/images/portfolio/uwc.jpg";


const ProjectsPreviewData = [
  {
    id: "pet-feeder",
    img: PetFeeder,
    name: "Automatic Pet Feeder",
    stack: ["< C++ />", "< ESP8266 />", "< ARQ Control Error />"],
    source: "https://github.com/tien2612/Automatic-Pet-Feeder",
    description:
      "The Automatic Pet Feeder offers scheduled feeding, portion control, and remote dispensing. With the integrated mobile app, you can easily manage your pet's feeding schedule, dispense food, and monitor their meals. Keep your pet well-fed and cared for, even when you're not at home.",
  },
  {
    id: "parking-system",
    img: ParkingSystem,
    name: "Smart Parking System",
    stack: ["< C++ />", "< RF Network />", "< ARQ Control Error />"],
    source: "https://github.com/tien2612/ParkingSystemIOT",
    description:
      "A smart parking system that tracks available slots, simplifying parking searches. Reserve booking slots in advance for a seamless parking experience. Say goodbye to wasted time and effortlessly find parking spaces with our innovative solution.",
  },
  {
    id: "plant-disease",
    img: PlantDisease,
    name: "Plant Disease and Pests Detection",
    stack: ["< React.Js />", "< Firebase />"],
    src: "https://plant-disease-website.vercel.app/",
    source: "https://github.com/tien2612/Plant-Disease-Website",
    description:
      "A website for farmers and growers to identify and treat plant diseases and pests through image analysis and environmental monitoring.",
  }
];

const ProjectsData = [
  {
    id: "pet-feeder",
    img: PetFeeder,
    name: "Automatic Pet Feeder",
    stack: ["< C++ />", "< ESP8266 />", "< ARQ Control Error />"],
    source: "https://github.com/tien2612/Automatic-Pet-Feeder",
    description:
      "The Automatic Pet Feeder offers scheduled feeding, portion control, and remote dispensing. With the integrated mobile app, you can easily manage your pet's feeding schedule, dispense food, and monitor their meals. Keep your pet well-fed and cared for, even when you're not at home.",
  },
  {
    id: "parking-system",
    img: ParkingSystem,
    name: "Smart Parking System",
    stack: ["< C++ />", "< RF Network />", "< ARQ Control Error />"],
    source: "https://github.com/tien2612/ParkingSystemIOT",
    description:
      "A smart parking system that tracks available slots, simplifying parking searches. Reserve booking slots in advance for a seamless parking experience. Say goodbye to wasted time and effortlessly find parking spaces with our innovative solution.",
  },
  {
    id: "plant-disease",
    img: PlantDisease,
    name: "Plant Disease and Pests Detection",
    stack: ["< React.Js />", "< Firebase />"],
    src: "https://plant-disease-website.vercel.app/",
    source: "https://github.com/tien2612/Plant-Disease-Website",
    description:
      "A website for farmers and growers to identify and treat plant diseases and pests through image analysis and environmental monitoring.",
  },
  {
    id: "uwc-2.0",
    img: UWC,
    name: "Urban waste collection aid",
    stack: ["< React.Js />", "< Node.Js />", "< MongoDB />", "< RESTful API />"],
    src: "https://plant-disease-website.vercel.app/",
    source: "https://github.com/tien2612/UWC-2.0",
    description:
      "A website helps Back officers coordinate schedules and routes, assigning tasks to collectors and janitors in waste collection. Janitors manually collect garbage and transport it to designated MCPs using trolleys. Collectors then retrieve the garbage from MCPs, following predetermined routes.",
  }
];

export { ProjectsData, ProjectsPreviewData };
